import { TextField } from "@mui/material";
import { sendFindPasswordMail } from "@src/api/sign";
import LeftBox from "@src/component/LeftBox";
import SignButton from "@src/component/SignButton";
import { BackGround, Content, EmptySpace, Layout } from "@src/component/SignComponent";
import useLoader from "@src/hook/useLoader";
import { globalSnackbarState } from "@src/state";
import { validateEmail } from "@src/utils/sign";
import type { NextPage, NextPageContext } from "next";
import { useRouter } from "next/router";
import { useState } from "react";
import { useSetRecoilState } from "recoil";

interface FindPasswordProps {
	type: "client" | "expert";
}

const FindPassword: NextPage<FindPasswordProps> = (props) => {
	const [email, setEmail] = useState("");
	const [isSend, setIsSend] = useState(false);
	const { type = "client" } = props;

	const router = useRouter();

	const withLoader = useLoader();
	const setSnackbareState = useSetRecoilState(globalSnackbarState);

	let signInText = "전문가 비밀번호 재설정";
	if (type === "client") {
		signInText = "고객사 비밀번호 재설정";
	}

	const onClickPasswordFind = async () => {
		if (!email || !validateEmail(email)) {
			setSnackbareState("이메일 형식이 맞지 않습니다.");
			return;
		}
		try {
			const result = await withLoader(sendFindPasswordMail(email));
			if (result.id) {
				setIsSend(true);
			} else {
				setSnackbareState("메일 보내기 실패");
			}
		} catch (error: any) {
			setSnackbareState(error.errorMessage || error.message);
		}
	};

	return (
		<BackGround>
			<Layout>
				<LeftBox type={type}></LeftBox>
				<Content>
					<div className="container">
						{!isSend && (
							<>
								<div className="title">{signInText}</div>
								<EmptySpace space={5} />
								<div className="description1">가입하신 이메일을 입력해주세요</div>
								<EmptySpace space={20} />
								<EmptySpace space={16} />
								<TextField
									label="이메일"
									fullWidth
									value={email}
									placeholder="hello@1point.kr"
									onChange={(e) => setEmail(e.target.value)}
								/>
								<EmptySpace space={16} />
								<SignButton
									text="비밀번호 재설정하기"
									onClick={onClickPasswordFind}
								></SignButton>
							</>
						)}
						{isSend && (
							<>
								<EmptySpace space={10} />
								<div className="title">이메일을 보냈습니다</div>
								<EmptySpace space={35} />
								<div className="description2">{`${email}로\n보낸 이메일을 확인해주세요`}</div>
								<EmptySpace space={16} />
								<SignButton
									text="로그인하기"
									onClick={() => {
										router.replace(type === "client" ? `/` : `/expert`);
									}}
								></SignButton>

								<EmptySpace space={30} />
							</>
						)}
					</div>
				</Content>
			</Layout>
		</BackGround>
	);
};

FindPassword.getInitialProps = async (ctx: NextPageContext) =>
	// if (ctx.query.a === "1") throw new Error();
	// console.log(ctx);
	// return { a: ctx.query.a };
	({ type: (ctx.query.type as "client" | "expert") || "client" });

export default FindPassword;
